import type { ApiQuery } from '../../../shared/api/contracts'
import { apiRequest, apiGet } from './transport'

export function fetchDetailedAnalytics(params: ApiQuery<'GET /admin/analytics/summary'>, signal?: AbortSignal) {
  return apiRequest<'GET /admin/analytics/summary'>(`/admin/analytics/summary?${new URLSearchParams(params)}`, { signal })
}

export async function fetchAnalyticsSeries(params: ApiQuery<'GET /admin/analytics/series'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  u.set('granularity', params.granularity)
  if (params.dateFrom) u.set('dateFrom', params.dateFrom)
  if (params.dateTo) u.set('dateTo', params.dateTo)
  if (params.compare) u.set('compare', params.compare)
  return apiGet<'GET /admin/analytics/series'>(`/admin/analytics/series?${u.toString()}`, signal)
}

export async function fetchAnalyticsBreakdown(params: ApiQuery<'GET /admin/analytics/breakdown'>, signal?: AbortSignal) {
  const u = new URLSearchParams()
  if (params.dateFrom) u.set('dateFrom', params.dateFrom)
  if (params.dateTo) u.set('dateTo', params.dateTo)
  return apiGet<'GET /admin/analytics/breakdown'>(`/admin/analytics/breakdown?${u.toString()}`, signal)
}
